"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductDescription = exports.getProductSizeName = exports.getProductTitle = void 0;
const tiles_1 = require("../consts/tiles");
const LOCALES = {
    en: {
        title: {
            main: 'Restickable Framed Art Prints',
            category_name: 'Art',
            suffix: 'Framed Wall Art - Gallery Wall - Wall Decor - Art on Canvas - Shop Art Online',
        },
        description: 'Shop online beautiful & affordable framed art prints. Curated artworks by the world\'s best artists. High-definition art prints with top quality frames. Frames are restickable with no wall damage! Say goodbye to nails and hello to mixtiles art. Simply choose the art & framing design to suit your decor. Delivered right to your door and ready to hang! Shipping is fast. Available in multiple sizes & frames',
    },
    es: {
        title: {
            main: 'Impresiones de arte enmarcadas reutilizables',
            category_name: 'Arte',
            suffix: 'Arte enmarcado para pared - Pared de galería - Decoración de pared - Arte en lienzo - Comprar arte en línea',
        },
        description: 'Compra en línea impresiones de arte enmarcadas, hermosas y asequibles. Obras de arte seleccionadas de los mejores artistas del mundo. Impresiones de arte en alta definición con marcos de primera calidad. ¡Los marcos se pueden volver a pegar sin dañar la pared! Di adiós a los clavos y hola al arte de Mixtiles. Simplemente elige el diseño del arte y del marco que se adapte a tu decoración. ¡Entregado directamente a tu puerta y listo para colgar! Envío rápido. Disponible en varios tamaños y marcos.',
    },
    fr: {
        title: {
            main: 'Impressions d\'art encadrées repositionnables',
            category_name: 'Art',
            suffix: 'Art mural encadré - Mur de galerie - Décoration murale - Art sur toile - Acheter de l\'art en ligne',
        },
        description: 'Achetez en ligne de magnifiques impressions d\'art encadrées à des prix abordables. Œuvres d\'art sélectionnées par les meilleurs artistes du monde. Impressions d\'art en haute définition avec des cadres de qualité supérieure. Les cadres se repositionnent sans abîmer le mur ! Dites adieu aux clous et bonjour à l\'art Mixtiles. Choisissez simplement le design artistique et le cadre qui conviennent à votre décoration. Livré directement chez vous et prêt à être accroché ! Livraison rapide. Disponible en plusieurs tailles et cadres.',
    },
    de: {
        title: {
            main: 'Wiederklebbar Gerahmte Kunstdrucke',
            category_name: 'Kunst',
            suffix: 'Gerahmte Wandkunst - Galeriewand - Wanddekoration - Kunstdrucke auf Leinwand - Kunst online kaufen',
        },
        description: 'Online schöne und erschwingliche gerahmte Kunstdrucke kaufen. Sorgfältig ausgewählte Kunstwerke der besten Künstler der Welt. Hochauflösende Kunstdrucke mit hochwertigen Rahmen. Rahmen sind wiederklebbar, ohne Wandschäden zu verursachen! Verabschieden Sie sich von Nägeln und begrüßen Sie Mixtiles Kunst. Wählen Sie einfach das Kunst- und Rahmendesign, das zu Ihrer Einrichtung passt. Direkt zu Ihnen geliefert und bereit zum Aufhängen! Schneller Versand. Erhältlich in verschiedenen Größen und Rahmen.',
    },
};
function getProductTitle(title, categories, size, language = 'en') {
    return [
        LOCALES[language]['title']['main'],
        title,
        size.split('_')[1].toLocaleUpperCase(),
        ...categories.map((c) => `${c} ${LOCALES[language]['title']['category_name']}`),
        LOCALES[language]['title']['suffix'],
    ].join(' - ');
}
exports.getProductTitle = getProductTitle;
function getProductSizeName(size, country) {
    return ['us', 'ca'].includes(country.toLocaleLowerCase())
        ? size.split('_')[1].toLocaleUpperCase()
        : (0, tiles_1.getSizesData)()[size].longDisplayNameCms;
}
exports.getProductSizeName = getProductSizeName;
function getProductDescription(language = 'en') {
    return LOCALES[language]['description'];
}
exports.getProductDescription = getProductDescription;
//# sourceMappingURL=productPageUtils.js.map